import { fetchAuthenticatedJson } from './authenticatedFetch';

export function fetchMonitoringOverview() {
  return fetchAuthenticatedJson('/api/admin/monitoring/overview');
}

export function fetchMonitoringServices() {
  return fetchAuthenticatedJson('/api/admin/monitoring/services');
}

export function fetchMonitoringImageQueue() {
  return fetchAuthenticatedJson('/api/admin/monitoring/image-queue');
}

export function fetchMonitoringAlerts(state = 'OPEN') {
  return fetchAuthenticatedJson(`/api/admin/monitoring/alerts?state=${encodeURIComponent(state)}`);
}

export function acknowledgeMonitoringAlert(id) {
  return fetchAuthenticatedJson(`/api/admin/monitoring/alerts/${id}/acknowledge`, { method: 'POST' });
}

export function resolveMonitoringAlert(id) {
  return fetchAuthenticatedJson(`/api/admin/monitoring/alerts/${id}/resolve`, { method: 'POST' });
}
